import { Component, OnInit, Input } from '@angular/core';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab2',
  templateUrl: '../../pages/afiliacion/afiliacion.tab2.html',
  styleUrls: ['../../pages/afiliacion/afiliacion.tab.component.css']
})
export class AfiliacionTab2Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    comunas: any
    @Input() afiliado: Afiliado;
    
 
    constructor(private router:Router,  private dialog: MatDialog,
        private afiliacionService:AfiliacionService,
        private mantenedorUsuarioService:MantenedorUsuariosService) { }

    ngOnInit(): void
    {
        let vm = this
      
    }
   

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    traeComunas() {
        let vm = this
    
        this.comunas = []
        this.mantenedorUsuarioService.traeComunas(vm.afiliado.idRegion).then(comunas => vm.afiliado.comunas = comunas)
    }

    soloNumeros(event: any) {
        // Obtenemos el valor actual del input
        let inputValue = event.target.value;
    
        // Removemos cualquier carácter que no sea un número usando una expresión regular
        inputValue = inputValue.replace(/[^0-9]/g, '');
    
        // Actualizamos el valor del input con solo números
        event.target.value = inputValue;
    }
    
    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
